import PersonIcon from './person';
export default PersonIcon;
